import { useState } from 'react'
import { Form, Input, Button, notification } from 'antd'
import { updateUser, createUser } from '../../../api/user';
import RoleSelect from '../../common/RoleSelect';
import LocationSelect from '../../common/LocationSelect';
import { useApp } from '../../../model';
import { useAuthInfo } from '../../../hooks';
import { ROLES } from '../../../constants';
export default function UserUpsert({
    initialValues,
    onComplete
}: {
    initialValues?: Partial<UserRecord>;
    onComplete: () => void;
}) {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    const { loadingAuthInfo, isManager, isRegionalHeader } = useAuthInfo();
    const isEdit = !!initialValues?.userId;
    const { currentUser } = useApp()
    const [currentRoleOptions, setCurrentRoleOptions] = useState<{ value: string, label: string, name: string }[]>([]);
    const [currentOrgOptions, setCurrentOrgOptions] = useState<{ value: string, label: string }[]>([]);
    const isAdmin = !!currentUser?.roles.find(i => i.name === 'ADMIN');
    return (
        <Form form={form} initialValues={{
            ...initialValues,
            roles: initialValues?.roles?.map(i => i.roleId),
            organizations: initialValues?.organizations?.map(i => i.organizationId),
        }} {
            ...{
                labelCol: { span: 4 },
                wrapperCol: { span: 20 },
            }
            }>
            <Form.Item name='name' label='姓名' rules={[{ required: true }]}>
                <Input />
            </Form.Item>
            <Form.Item name='roles' label='角色' rules={[{ required: true }]}>
                <RoleSelect loading={loadingAuthInfo} optionsFormatter={(options = []) => {
                    return options.map(opt => {
                        return {
                            ...opt,
                            disabled:
                                isManager ?
                                    (opt.name !== ROLES.ELECTRICIAN) :
                                    (
                                        isRegionalHeader ?
                                            (opt.name !== ROLES.ELECTRICIAN && opt.name !== ROLES.MANAGER) :
                                            false
                                    )

                        }
                    })
                }} allowAdminSelection={isAdmin && !!initialValues?.roles?.find(i => i.name === 'ADMIN')} mode='multiple' maxCount={1} onOptionChange={setCurrentRoleOptions} />
            </Form.Item>
            <Form.Item name='organizations' label='展馆' rules={[{ required: true }]}>
                <LocationSelect
                    // maxTagCount={1}
                    loading={loadingAuthInfo} optionsFormatter={(options = []) => {
                        return options.map(opt => {
                            return {
                                ...opt,
                                disabled: (isManager || isRegionalHeader) ? (
                                    !currentUser?.organizations.find(o => o.organizationId === opt.value)
                                ) : false
                            }
                        })
                    }}
                    maxCount={isAdmin ? undefined : 1} mode='multiple' onOptionChange={setCurrentOrgOptions} />
            </Form.Item>
            <Form.Item name='phone' label='手机号码' rules={[{ required: true, validator: (rule, value: string) => {
                return /^1[3456789]\d{9}$/gi.test(value) ? Promise.resolve() : Promise.reject('电话号码格式错误')
            } }]}>
                <Input />
            </Form.Item>
            <Form.Item name='email' label='邮箱' rules={[{ required: false, type: 'email' }]}>
                <Input />
            </Form.Item>
            <div style={{ textAlign: 'center' }}>
                <Button loading={submitting} onClick={async () => {
                    let values;
                    try {
                        values = await form.validateFields();
                    } catch (err) {
                        console.error(err)
                    }
                    if (!values) return;
                    const payload = {
                        ...initialValues,
                        ...values,
                        organizations: values.organizations.map((organizationId: any) => {
                            const option = currentOrgOptions.find(i => i.value === organizationId)
                            return {
                                organizationId: option?.value,
                                name: option?.label
                            }
                        }),
                        roles: values.roles.map((roleId: any) => {
                            const option = currentRoleOptions.find(i => i.value === roleId)
                            return {
                                roleId: option?.value,
                                name: option?.name
                            }
                        })
                    };
                    setSubmitting(true);
                    try {
                        if (isEdit) {
                            await updateUser(initialValues.userId!, payload)
                        } else {
                            await createUser(payload)
                        }
                        notification.success({ message: isEdit ? '更新成功' : '创建成功' })
                        onComplete()
                    } catch (err: any) {
                        notification.error({ message: err.message || (isEdit ? '更新失败, 请重试' : '创建失败, 请重试' )})
                    }
                    setSubmitting(false);
                }
                } type='primary'>确认</Button>
            </div>
        </Form >
    )
}